<template>
  <div>
    <Toast position="bottom-right" group="br" />

    <!-- <div class="container-fluid bg-light"> -->
    <div class="form col-lg-10 mx-auto bg-white">
      <h6 class="text-center mt-2 mb-3 heading">
        Register Branches of your company
      </h6>
      <form class="col-lg-11 mx-auto" @submit.prevent="newBranch()">
        <div class="inputs d-flex flex-wrap mx-auto">
          <div class="form-group col-12 col-sm-6 col-lg-3">
            <input
              type="text"
              class="form-control"
              name="branchName"
              v-model="name"
              placeholder="Branch name"
              required
            />
          </div>
          <div class="form-group col-12 col-sm-6 col-lg-4">
            <input
              type="text"
              class="form-control"
              name="branchLocation"
              v-model="location"
              placeholder="office location"
              required
            />
          </div>
          <div class="form-group col-12 col-sm-6 col-lg-3">
            <select
              class="form-control"
              v-model="shaloi"
              name="shaloi"
              id="shaloi"
              required
            >
              <option disabled value>Select branch shaloi</option>
              <option
                v-for="shaloi in shalois"
                :key="shaloi.shaloiId"
                :value="shaloi.shaloiId"
                >{{ shaloi.Firstname + " " }}{{ shaloi.Lastname }}</option
              >
            </select>
          </div>
          <div class="text-center col-12 col-sm-6 col-lg-2">
            <button
              type="submit"
              name="newbranch"
              class="btn col-12 col-sm-12 btn-primary"
            >
              Add branch
            </button>
          </div>
        </div>
      </form>

      <div class="added-branches col-lg-10 mx-auto">
        <div
          v-if="showTable"
          class="table-container card my-3 col-lg-12 p-0 mx-auto"
        >
          <table class="table col-lg-12">
            <thead class="bg-success">
              <tr>
                <th>#</th>
                <th>Branch name</th>
                <th>Branch location</th>
                <th>Branch shaloi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="branch in branches" :key="branch">
                <td>{{ branch.no }}</td>
                <td>{{ branch.name }}</td>
                <td>{{ branch.location }}</td>
                <td>{{ branch.shaloiName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
const url = `https://bookinga.herokuapp.com/api/v1/company/branches`;
import axios from "axios";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  props: {
    shalois: { type: Array },
  },
  data() {
    return {
      showTable: false,
      location: "",
      shaloi: "",
      name: "",
      clicksCounter: 0,
      branches: [],
    };
  },
  methods: {
    newBranch() {
      if (this.name != "" && this.shaloi != "" && this.location != "") {
        axios
          .post(
            url,
            {
              shaloiId: this.shaloi,
              branchname: this.name,
              office_location: this.location,
            },
            config
          )
          .then((res) => {
            if (res.data.message == "successfuly registered branch") {
              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Branch saved successfully",
                group: "br",
                life: 5000,
              });
              var sel = document.getElementById("shaloi");
              var shaloiName = sel.options[sel.selectedIndex].text;
              this.clicksCounter++;
              this.branches.push({
                name: this.name,
                shaloi: this.shaloi,
                shaloiName: shaloiName,
                location: this.location,
                no: this.clicksCounter,
              });
              this.showTable = true;
              this.name = "";
              this.shaloi = "";
              this.location = "";
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: res.data.message,
                group: "br",
                life: 5000,
              });
            }
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: error.message,
              group: "br",
              life: 5000,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
@import 'sharedStylesReg.css';
.form {
    border-radius: 10px;
    height: 84.2vh;
}

button.btn.btn-primary {
    width: 100%;
    background: #0069d9;
    font-size: 13px;
}
</style>
